import React from 'react'
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom"
import { appPages } from './Pages'
import { IPage } from './Interfaces'
import BasePage from '../../pages/BasePage'
import NavigationTracker from './NavigationTracker'

export default function Router() {
    
    const pages = appPages
    const renderRoutes = () => pages.map((page: IPage, index: number) => <Route  path={page.path} key={index} element={<BasePage page={page} />} />)

    return(
        <BrowserRouter>
            <NavigationTracker />
            <Routes>
                {renderRoutes()}
            </Routes>
        </BrowserRouter>
    )
}